import ChatWidget from './ChatWidget';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDocument } from './EditBookPage';
import Button from 'components/Button';
import { LeftOutlined } from '@ant-design/icons';

export default function DocumentPage() {

    let [searchParams, setSearchParams] = useSearchParams();
    let { document_id } = useParams();
    let { data, error, isLoading, refetch } = useDocument(document_id)
    const navigate = useNavigate();

    const file = data?.file

    let url = file?.url
    if (searchParams.get("page")) {
        url += `#page=${searchParams.get("page")}`
    }
    return (
        <div className='w-100 h-100 d-flex flex-column'>
            <div className='ml-5 mb-3 mt-3'>
                <Button
                    variant='is-light'
                    className='py-1'
                    onClick={() => navigate(-1)}
                >
                    <LeftOutlined className='mr-2' />
                    Back
                </Button>
            </div>
            <div className="columns" style={{ flex: 1 }}>
                <div className="column" style={{ maxWidth: "50%", overflowX: "hidden" }}>
                    <ChatWidget book_id={document_id} />
                </div>
                <div className="column">
                    <iframe
                        title='document'
                        key={url}
                        width="100%"
                        height="100%"
                        src={url}
                        frameBorder="0"
                    />
                </div>
            </div>

        </div>
    );
}